var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`dialer-main-loader `},[_c('img',{attrs:{"src":_vm.loaderV3,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }